import { BehaviorSubject } from 'rxjs';
import { Dispatch, SetStateAction } from 'react';

export enum ErrorType {
  SystemNotFound,
  ApiServiceError,
  ReactError,
  ShortcutNotFound,
}

export type ErrorState = {
  systemNotFound: boolean;
  apiServiceError: boolean;
  reactError: boolean;
};

type SetStateType = { hasError: boolean; errorType: ErrorType };

const initialState: ErrorState = {
  systemNotFound: false,
  apiServiceError: false,
  reactError: false,
};

const state$ = new BehaviorSubject<ErrorState>(initialState);

const getState = () => {
  return state$.getValue();
};

const setState = (data: ErrorState) => {
  return state$.next({ ...data });
};

const getErrorType = (next: ErrorState) => {
  if (next.systemNotFound) {
    return ErrorType.SystemNotFound;
  } else if (next.apiServiceError) {
    return ErrorType.ApiServiceError;
  } else {
    return ErrorType.ReactError;
  }
};

const ErrorBoundaryService = {
  setErrorBoundaryState: (errorType: ErrorType) => {
    const state = getState();
    if (errorType === ErrorType.SystemNotFound) {
      state.systemNotFound = true;
    } else if (errorType === ErrorType.ApiServiceError) {
      state.apiServiceError = true;
    } else {
      state.reactError = true;
    }
    setState(state);
  },

  getErrorBoundaryState: (setErrorBoundaryState: Dispatch<SetStateAction<SetStateType>>) => {
    return state$.asObservable().subscribe((next) =>
      setErrorBoundaryState({
        hasError: next.systemNotFound || next.apiServiceError || next.reactError,
        errorType: getErrorType(next),
      }),
    );
  },
};

export default ErrorBoundaryService;
